import Vue from "vue";
import Config from "@/config";
import {applyNotificationUpdateFromPayload} from "@/utils/task";

const mutations = {
    notificationRemind: (state, payload) => {
        console.log("MUTATION notificationRemind", payload);
    },
    notificationRead: (state, payload) => {
        console.log("MUTATION notificationRead", payload);

        if ( payload?.isFromServer ) {
            applyNotificationUpdateFromPayload(state, payload);
        }
    },
    notificationReadAll: (state, payload) => {
        console.log("MUTATION notificationReadAll", payload);

        if ( payload?.isFromServer ) {
            applyNotificationUpdateFromPayload(state, payload);
        }
    },
    notificationUpdate: (state, payload) => {
        console.log("MUTATION notificationUpdate", payload);

        if ( payload?.isFromServer ) {
            applyNotificationUpdateFromPayload(state, payload);
        }
    },
};

export default mutations;
